/**
 * Decorative only: aria-hidden and free of focusable controls, so screen-reader and keyboard
 * users go straight to the form. Removed below 900px by the media query in AuthLayout rather
 * than stacked above the form, which would push the email field below the fold on a phone.
 */
export function BrandPanel() {
  return (
    <div data-testid="auth-brand-panel" aria-hidden="true" className="auth-brand-panel">
      <div className="auth-brand-glow" />

      <div className="auth-wordmark">
        OVRSEE
        <span className="auth-wordmark-dot" />
      </div>

      <div style={{ maxWidth: 400, display: 'flex', flexDirection: 'column', gap: 28, position: 'relative' }}>
        <div className="auth-metric-card">
          <div className="auth-metric-label">Team efficiency · Q3</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 10 }}>
            <span className="auth-metric-stat">87.2</span>
            <span className="auth-metric-chip">▲ 12.4%</span>
          </div>
          <div className="auth-metric-caption">complexity-weighted score</div>
          <svg viewBox="0 0 200 36" preserveAspectRatio="none" style={{ width: '100%', height: 36, marginTop: 12 }}>
            <polyline
              points="0,30 28,27 56,28 84,20 112,22 140,13 168,9 200,3"
              fill="none"
              stroke="var(--mauve-400)"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div>
          <p className="auth-tagline">Coaching, not surveillance.</p>
          <p className="auth-subcopy">
            Ovrsee gives managers honest, complexity-weighted insight into how their teams
            perform — without putting anyone in a leaderboard war.
          </p>
        </div>
      </div>

      <div className="auth-trust">Trusted by 400+ operations teams</div>
    </div>
  )
}
